import axios from "axios";
import { API_HOST, ALT_DOMAIN_ID } from "@/core/variables";
import { IntentCreate, IntentTransfer, IntentUpdate } from "@/model";

class IntentRepository {
    find = async (
        agentId: number,
        skillId: number,
    ) => {
        return axios
            .get(`${API_HOST}/v1/agents/${agentId}/domains/${ALT_DOMAIN_ID}/skills/${skillId}/intents`)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    create = async (
        agentId: number,
        skillId: number,
        form: IntentCreate
    ) => {
        return axios
            .post(`${API_HOST}/v1/agents/${agentId}/domains/${ALT_DOMAIN_ID}/skills/${skillId}/intents`, {
                ...form
            })
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    update = async (
        agentId: number,
        skillId: number,
        intentId: string,
        form?: IntentUpdate
    ) => {
        return axios
            .put(`${API_HOST}/v1/agents/${agentId}/domains/${ALT_DOMAIN_ID}/skills/${skillId}/intents/${intentId}`, {
                ...form
            })
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    transfer = async (
        agentId: number,
        skillId: number,
        form?: IntentTransfer
    ) => {
        return axios
            .put(`${API_HOST}/v1/agents/${agentId}/domains/${ALT_DOMAIN_ID}/skills/${skillId}/intents-transfer`, {
                ...form
            })
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    delete = async (
        agentId: number,
        skillId: number,
        intentId: string,
    ) => {
        return axios
            .delete(`${API_HOST}/v1/agents/${agentId}/domains/${ALT_DOMAIN_ID}/skills/${skillId}/intents/${intentId}`)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    getNames = async (agentId: number) => {
        return axios.get(`${API_HOST}/v1/agents/${agentId}/intents`);
    };
}


const intentRepository = new IntentRepository();

export default intentRepository;